module.exports = __webpack_public_path__ + "c3ab17cda7131d0e0fb719c99ea0061b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/helmet-astronaut.png
// module id = 2307
// module chunks = 0